import React from "react";
import GitHubCalendar from "react-github-calendar";
import Reveal from "../ui/Reveal";

function Github() {
  return (
    <Reveal className="card-surface p-6 sm:p-8">
      <h3 className="font-display text-lg font-semibold text-ink">
        Days I <span className="text-accent-soft">code</span>
      </h3>
      <p className="mt-1 text-sm text-ink-faint">My contribution graph on GitHub.</p>
      <div className="mt-6 overflow-x-auto">
        <GitHubCalendar
          username="m-abdullah-shakoor"
          blockSize={13}
          blockMargin={4}
          fontSize={13}
          style={{ color: "#a9a9c0" }}
          theme={{
            level0: "#1c1c28",
            level1: "#4c1d95",
            level2: "#6d28d9",
            level3: "#8b5cf6",
            level4: "#c4b5fd",
          }}
        />
      </div>
    </Reveal>
  );
}

export default Github;
